import cx from 'classnames'
import type React from 'react'

import type { UsageBucket } from '@/services/apiUsage'
import { formatCount, formatPercent } from '../../../../utils'
import css from './styles.module.scss'

interface UsageCardProps {
  label: string
  bucket: UsageBucket
}

export const UsageCard: React.FC<UsageCardProps> = ({ label, bucket }) => {
  const percent = bucket.limit > 0 ? (bucket.used / bucket.limit) * 100 : 0

  const className = cx(css.card, {
    [css.almost_full]: percent >= 85 && percent <= 98,
    [css.full]: percent > 98,
  })

  return (
    <div className={className}>
      <div className={css.label}>{label}</div>

      <div className={css.value}>
        {formatCount(bucket.used)}
        <span className={css.limit}> / {formatCount(bucket.limit)}</span>
      </div>

      <div className={css.percent}>{formatPercent(percent)} used</div>

      <div className={css.progress}>
        <div
          className={css.progress_bar}
          style={{ width: `${Math.min(100, percent)}%` }}
        />
      </div>

      <div className={css.remaining}>
        {formatCount(bucket.remaining)} requests left
      </div>
    </div>
  )
}
